// @ts-strict-ignore
import {PRIMITIVE_MATH_TYPES} from 'common/types/reports/bookmark';
import {
  ControlBarAction,
  ControlBarActionItems,
  ControlSelectEntryPoint,
} from 'common/query-builder/query-entry-section/constants';
import {QueryEntrySectionTrackingEvent} from 'common/query-builder/query-entry-section/tracking';

import type {RowProps} from '../catalog';

/**
 * Displays overflow menu actions specific for simple metrics
 */
export function simpleMetricCustomActions(props: RowProps) {
  const handleCustomizeBuckets = () => {
    props.setActiveMenu(`customizeBuckets`);

    const customBucket = props.entry.behavior.customBucket;

    // TODO: Should we reuse tracking from "openCustomBucket" somehow?
    props.dispatchTrack(QueryEntrySectionTrackingEvent.OpenCustomBucketPane, {
      ...props.getEntryTrackingProps(),
      ...(customBucket
        ? {
            'Bucket min': customBucket.min,
            'Bucket max': customBucket.max,
            'Bucket size': customBucket.bucketSize,
          }
        : {}),
      'Is editing': !!customBucket,
      entryPoint: ControlSelectEntryPoint.ControlBar,
      'Property Type': null,
    });
  };

  return [
    /** "Customize Bucket" action for distribution metrics */
    props.sectionProps?.canCustomizeNumericBuckets &&
      props.entry?.measurement.aggregationOperator === PRIMITIVE_MATH_TYPES.HISTOGRAM && {
        ...ControlBarActionItems[ControlBarAction.CustomizeBuckets],
        onSelect: () => handleCustomizeBuckets(),
      },
  ];
}
